import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';

export const HeroSection = ({ companyInfo }) => (
  <section className="bg-gradient-to-b from-slate-900 to-slate-800 text-white py-12 md:py-20 relative overflow-hidden">
    <div
      className="absolute inset-0 bg-cover bg-center opacity-50"
      style={{
        backgroundImage: "url('https://images.unsplash.com/photo-1759844197486-5b3612c7d534?crop=entropy&cs=srgb&fm=jpg&q=85')"
      }}
    />
    <div className="absolute inset-0 bg-gradient-to-b from-slate-900/70 to-slate-800/70" />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
      <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
        <div className="flex justify-center md:justify-start order-2 md:order-1">
          <img
            src={companyInfo.logo}
            alt="Den Cyber Solutions"
            className="w-64 h-64 md:w-96 md:h-96 lg:w-[500px] lg:h-[500px] object-contain"
          />
        </div>
        <div className="order-1 md:order-2">
          <Badge className="mb-4 bg-[#105EFF] hover:bg-[#0D4FCC] text-white border-0">Governance, Risk & Compliance</Badge>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 md:mb-6 leading-tight">
            {companyInfo.slogan}
          </h1>
          <p className="text-lg md:text-xl text-slate-300 mb-6 md:mb-8 leading-relaxed">
            {companyInfo.mission}
          </p>
          <div className="flex flex-col sm:flex-row flex-wrap gap-4">
            <Button size="lg" asChild className="bg-[#105EFF] hover:bg-[#0D4FCC] text-white w-full sm:w-auto">
              <a href="#contact">Get Started <ArrowRight className="ml-2 h-4 w-4" /></a>
            </Button>
            <Button size="lg" variant="outline" className="bg-transparent border-white text-white hover:bg-white hover:text-slate-900 w-full sm:w-auto">
              <a href="#services">Our Services</a>
            </Button>
          </div>
        </div>
      </div>
    </div>
  </section>
);
